import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import MainLayout from "./components/mainlayout";
import ServiceWrapper from "./components/services-wrapper";
import HiddenPageWrapper from "./components/hiddenpage-wrapper";
import HomePage from "./pages/home";
const AboutPage = lazy(() => import("./pages/about"));
const ProjectsPage = lazy(() => import("./pages/projects"));
const ContactPage = lazy(() => import("./pages/contact"));

const Design = lazy(() => import("./pages/services/design"));
const Development = lazy(() => import("./pages/services/development"));
const LandingPage = lazy(() => import("./pages/services/landing"));
const Hosting = lazy(() => import("./pages/services/hosting"));
const Consulting = lazy(() => import("./pages/services/consulting"));
const Booking = lazy(() => import("./pages/services/booking"));
const LandingAndMore = lazy(() => import("./pages/services/landingandmore"));
const Plumbing = lazy(() => import("./pages/plumbing"));
function App() {
  return (
    <>
      <MainLayout>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/plumbing" element={<Plumbing />} />
            <Route path="/services" element={<LandingPage />} />
            <Route path="/landing-more" element={<LandingAndMore />} />
            <Route path="/design" element={<Design />} />
            <Route path="/development" element={<Development />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/hosting-maintenance" element={<Hosting />} />
            <Route path="/services/:slug" element={<ServiceWrapper />} />
            <Route path="/:name" element={<HiddenPageWrapper />} />
          </Routes>
        </Suspense>
      </MainLayout>
    </>
  );
}

export default App;
